export const isShareAPISupported = 'share' in navigator
